import { VFC } from 'react'
import { CompanyData, LoginUser } from 'src/models/User'
import { getFoundedYears, LISTED_OPTIONS } from 'src/utils/data'
import {
  BooleanSelect,
  FormInput,
  FormSelect,
  FormTextarea,
  MasterDataSelect,
  ProfileForm,
} from '../formComponents'
import { MasterDataMultiSelectWithType } from '../formComponents/FormMultiSelect'
import { ProfileEditorWrapper } from '../ProfileLayout'

type CompanyDataFormProps = {
  user: LoginUser
  submit: (company: CompanyData) => Promise<any>
}

export const CompanyDataForm: VFC<CompanyDataFormProps> = ({
  user,
  submit,
}) => (
  <ProfileEditorWrapper user={user}>
    <ProfileForm
      title="企業情報"
      user={user}
      propertyKey="company"
      submit={submit}
      isProfile
    >
      <FormInput
        id="name"
        label="企業名"
        placeholder="例:株式会社オンリーストーリー"
      />
      <FormInput
        id="nameRuby"
        label="企業名（ふりがな）"
        placeholder="例:かぶしきがいしゃおんりーすとーりー"
        optional
      />
      <MasterDataMultiSelectWithType
        type="businessTypes"
        id="businessType"
        label="業種"
      />
      <MasterDataSelect
        type="businessObjects"
        id="businessObject"
        label="商材"
      />
      <MasterDataSelect
        type="numberOfEmployees"
        id="numberOfEmployees"
        label="従業員数"
      />
      <FormSelect id="foundedOn" label="設立年数" options={getFoundedYears()} />
      <MasterDataSelect type="prefectures" id="prefecture" label="所在地" />
      <FormInput
        id="hpUrl"
        label="企業URL"
        placeholder="例:https://onlystory.co.jp/"
        type="link"
      />
      <MasterDataSelect type="capitals" id="capital" label="資本金" optional />
      <BooleanSelect
        id="isListed"
        label="上場or未上場"
        options={LISTED_OPTIONS}
        optional
      />
      <FormTextarea id="serviceDescription" label="事業・サービス紹介" />
    </ProfileForm>
  </ProfileEditorWrapper>
)
